import { render } from "./InputNome.vue?vue&type=template&id=13caa5c4&scoped=true"
import script from "./InputNome.vue?vue&type=script&lang=js"
export * from "./InputNome.vue?vue&type=script&lang=js"

import "./InputNome.vue?vue&type=style&index=0&id=13caa5c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13caa5c4"]])

export default __exports__